import React, { useEffect } from "react";

import bridge from "@/utils/dsBridge";
import { BridgeCallHandlers, log2ClientEventName, SurveyCompleteTypes } from "@/interfaces/enums";
import {
	confirmAccountOpeningAgreement,
	useAnswers,
	useQuestions,
	answerQuestions,
} from "@/hooks/useRequest/useSurveyRequest";
import { SurveyType } from "@/interfaces/surveyTypes";
import { useRouter } from "next/router";

import log2Sentry from "@/utils/log2Sentry";
import log2sensors, { SensorsEventIds } from "@/utils/log2sensors";
import { isInApp } from "@/utils/util";

import log2Client from "@/utils/log2Client";

import PolicyView from "./PolicyView";

interface PoliciesPageProps {
	unRejectedSubmissions?: boolean;
	afterSubmit?: () => Promise<boolean>;
}

export default function PoliciesPage({ unRejectedSubmissions = true, afterSubmit }: PoliciesPageProps) {
	const { answerFieldToValueMap } = useAnswers({
		type: SurveyType.ACCOUNT_OPENING,
	});
	const { questionFieldToIdMap } = useQuestions({
		type: SurveyType.ACCOUNT_OPENING,
	});

	const router = useRouter();

	const handleAgreement = async () => {
		try {
			const hasNotFinishedAnswerWithNotChinaTaxResident =
				questionFieldToIdMap.get("notChinaTaxResident") &&
				answerFieldToValueMap.get("notChinaTaxResident") === undefined;

			const hasNotFinishedAnswerWithTaxResidence =
				questionFieldToIdMap.get("taxResidence") && answerFieldToValueMap.get("taxResidence") === undefined;

			if (hasNotFinishedAnswerWithNotChinaTaxResident) {
				await answerQuestions({
					payload: [
						{
							answer: "1",
							questionId: questionFieldToIdMap.get("notChinaTaxResident"),
						},
					],
				});
			}

			// TODO: 兼容处理，开户到一半退出的用户
			if (hasNotFinishedAnswerWithTaxResidence) {
				await answerQuestions({
					payload: [
						{
							answer: answerFieldToValueMap.get("nationality") || "",
							questionId: questionFieldToIdMap.get("taxResidence"),
						},
					],
				});
			}

			await confirmAccountOpeningAgreement(SurveyType.ACCOUNT_OPENING);

			if (afterSubmit) {
				await afterSubmit();
			}
			bridge.call(BridgeCallHandlers.ON_SURVEY_COMPLETE, {
				questionType: SurveyCompleteTypes.OPEN_ACCOUNT,
			});
			log2Client({
				eventName: log2ClientEventName.openAccountSurveySubmitted,
			});
			if (unRejectedSubmissions) {
				log2sensors(SensorsEventIds.AO_AGREEMENTS_CONFIRMANDAGREE);
			}
			if (!isInApp()) {
				router.push("/survey/account-opening/success");
			}
		} catch (error) {
			log2Sentry(error);
		}
	};

	useEffect(() => {
		log2sensors(SensorsEventIds.AO_AGREEMENTS_VIEW);
	}, []);

	return <PolicyView onSubmit={handleAgreement} />;
}
